'use client';

import { c as _c } from "react/compiler-runtime";
import type { PropsWithStyles } from '@morpho-org/ui-v6/types';
import { useHasTouchInput } from '@repo/ui';
import { memo, type ReactNode, useState } from 'react';
import { HoverCard, HoverCardContent, HoverCardTrigger, Popover, PopoverContent, PopoverTrigger } from '@/components/common/overlays';
export interface VaultPendingTimelockInfoProps extends PropsWithStyles {
  children: ReactNode;
  content: ReactNode;
  sideOffset?: number;
  side?: 'bottom' | 'top' | 'left' | 'right';
}
const VaultPendingTimelockInfo = t0 => {
  const $ = _c(22);
  const {
    children,
    content,
    sideOffset: t1,
    side
  } = t0;
  const sideOffset = t1 === undefined ? 12 : t1;
  const [isOpen, setIsOpen] = useState(false);
  const hasTouchInput = useHasTouchInput();
  if (hasTouchInput) {
    let t2;
    if ($[0] !== isOpen) {
      t2 = e => {
        e.preventDefault();
        e.stopPropagation();
        setIsOpen(!isOpen);
      };
      $[0] = isOpen;
      $[1] = t2;
    } else {
      t2 = $[1];
    }
    let t3;
    if ($[2] !== children || $[3] !== t2) {
      t3 = <PopoverTrigger asChild={true}><div role="button" onClick={t2}>{children}</div></PopoverTrigger>;
      $[2] = children;
      $[3] = t2;
      $[4] = t3;
    } else {
      t3 = $[4];
    }
    let t4;
    if ($[5] !== content) {
      t4 = <PopoverContent className="p-0 outline-none max-md:mx-[calc((var(--radix-popover-content-available-width)-90vw)/2)] max-md:w-[90vw]" side="bottom" onOpenAutoFocus={_temp} onClick={_temp2}>{content}</PopoverContent>;
      $[5] = content;
      $[6] = t4;
    } else {
      t4 = $[6];
    }
    let t5;
    if ($[7] !== isOpen || $[8] !== t3 || $[9] !== t4) {
      t5 = <Popover open={isOpen} onOpenChange={setIsOpen}>{t3}{t4}</Popover>;
      $[7] = isOpen;
      $[8] = t3;
      $[9] = t4;
      $[10] = t5;
    } else {
      t5 = $[10];
    }
    return t5;
  }
  let t2;
  if ($[11] !== children) {
    t2 = <HoverCardTrigger asChild={true}><div role="button" onClick={_temp3}>{children}</div></HoverCardTrigger>;
    $[11] = children;
    $[12] = t2;
  } else {
    t2 = $[12];
  }
  let t3;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      minWidth: "400px",
      maxWidth: "315px"
    };
    $[13] = t3;
  } else {
    t3 = $[13];
  }
  let t4;
  if ($[14] !== content || $[15] !== side || $[16] !== sideOffset) {
    t4 = <HoverCardContent style={t3} sideOffset={sideOffset} align="center" side={side} onClick={_temp4}>{content}</HoverCardContent>;
    $[14] = content;
    $[15] = side;
    $[16] = sideOffset;
    $[17] = t4;
  } else {
    t4 = $[17];
  }
  let t5;
  if ($[18] !== isOpen || $[19] !== t2 || $[20] !== t4) {
    t5 = <HoverCard open={isOpen} onOpenChange={setIsOpen} openDelay={200} closeDelay={100}>{t2}{t4}</HoverCard>;
    $[18] = isOpen;
    $[19] = t2;
    $[20] = t4;
    $[21] = t5;
  } else {
    t5 = $[21];
  }
  return t5;
};
export default memo(VaultPendingTimelockInfo);
function _temp(e_0) {
  return e_0.preventDefault();
}
function _temp2(e_1) {
  return e_1.stopPropagation();
}
function _temp3(e_2) {
  e_2.stopPropagation();
}
function _temp4(e_3) {
  return e_3.stopPropagation();
}